/**
 * Configuration required for Amplify.
 * Ref: https://docs.amplify.aws/lib/client-configuration/configuring-amplify-categories/q/platform/js/
 */

export const envConfig = {
    Auth: {
        // (required) only for Federated Authentication - Amazon Cognito Identity Pool ID
        identityPoolId: 'us-east-1:02198b66-8786-49cf-8d74-0b6dddfb3368',

        // (required)- Amazon Cognito Region
        region: 'us-east-1',

        // (optional) - Amazon Cognito User Pool ID
        userPoolId: 'us-east-1_s1AJunG0v',

        // (optional) - Amazon Cognito Web Client ID (26-char alphanumeric string, App client secret needs to be disabled)
        userPoolWebClientId: 'iehle8buavv25a40474d6sgsr',

        // (optional) - Enforce user authentication prior to accessing AWS resources or not
        mandatorySignIn: true,

        // (optional) - Hosted UI configuration
        oauth: {
            domain: 'controllershiphub-dev-vigrat' + '.auth.us-east-1.amazoncognito.com',
            redirectSignIn: 'https://' + window.location.host + '/',
            redirectSignOut: 'https://' + window.location.host+ '/',
            //  redirectSignIn: 'http://localhost:4321/',
            //  redirectSignOut: 'http://localhost:4321/',
            scope: ['openid'],
            responseType: 'code',
        },
    },
};